var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.8267 0C38.5863 0 40.8267 2.24039 40.8267 5V35C40.8267 37.7596 38.5863 40 35.8267 40H5.82666C3.06705 40 0.82666 37.7596 0.82666 35V5C0.82666 2.24039 3.06705 0 5.82666 0H35.8267ZM34.113 7H29.6662L22.3374 15.3081L16.0021 7H6.82666L17.7897 21.2204L7.39913 33H11.8484L19.869 23.9117L26.8777 33H35.8267L24.3983 18.0139L34.113 7ZM30.5698 30.3601H28.1051L12.0195 9.50195H14.6639L30.5698 30.3601Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialX);
export default __webpack_public_path__ + "static/media/social-x.029f4a1b701c7fcda1960f482329ef75.svg";
export { ForwardRef as ReactComponent };